import { JetpacB2BApi } from 'api'

class TechnologyCompanyApi {
  static getTechnologyCompanyDetails(faberToken: string, search_termn: string) {
    const url = `/technology-company?search_term=${search_termn}`
    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }
  static getTechnologyCompanyById(faberToken: string, id: string) {
    const url = `/technology-company/${id}`
    return JetpacB2BApi.httpGet(
      url,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then((res) => res.data)
  }

  static async saveTechnologyCompanyDetails(
    body: TechCompanyBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPost(
      `technology-company`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }

  static updateTechnologyCompany(
    body: TechCompanyBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPut(
      `technology-company`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }

  static updateTechnologyCompanyStatus(
    body: TechCompanyStatusBackendData,
    faberToken: string
  ) {
    return JetpacB2BApi.httpPatch(
      `technology-company/status`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      body
    )
  }
}

export default TechnologyCompanyApi

export interface TechCompanyBackendData {
  technology_company_name: string
  commission: string
  currency: string
  value: string
  is_active: boolean
  created_by: string
  commission_type: string
  id?: string
  updated_by?: string
}

export interface TechCompanyStatusBackendData {
  id: string
  updated_by: string
  status: boolean
}
